import React, { useMemo } from 'react';

import { Type } from '@deqo/foundation';
import ace, { Ace } from 'ace-builds';

import 'ace-builds/src-noconflict/ext-language_tools';
import 'ace-builds/src-noconflict/mode-java';
import { Mode } from 'ace-builds/src-noconflict/mode-text';
import 'ace-builds/src-noconflict/theme-chrome';
import { CodeEditor, CodeEditorProps } from './CodeEditor';

const TextHighlightRules = ace.require('ace/mode/text_highlight_rules').TextHighlightRules as Type<Ace.HighlightRules>;
const TextMode = Mode as Type<Ace.SyntaxMode>;

class MqlHighlightRules extends TextHighlightRules {

    $rules = {} as any;

    constructor() {
        super();

        // regexp must not have capturing parentheses. Use (?:) instead.
        // regexps are ordered -> the first match is used

        const keywords = (
            'and|or|not|in|matches|like'
        );

        const builtinConstants = (
            'true|false|null'
        );

        const keywordMapper = this.createKeywordMapper({
            'keyword': keywords,
            'constant.language': builtinConstants,
        }, 'identifier', true);

        this.$rules = {
            'start': [{
                token: 'string',           // " string
                regex: '".*?"'
            }, {
                token: 'constant.numeric', // float
                regex: '[+-]?\\d+(?:(?:\\.\\d*)?(?:[eE][+-]?\\d+)?)?\\b'
            }, {
                token: keywordMapper,
                regex: '[a-zA-Z_$][a-zA-Z0-9_$]*\\b'
            }, {
                token: 'keyword.operator',
                regex: '\\+|\\-|\\/|\\/\\/|%|<@>|@>|<@|&|\\^|~|<|>|<=|=>|==|!=|<>|='
            }, {
                token: 'paren.lparen',
                regex: '[\\(]'
            }, {
                token: 'paren.rparen',
                regex: '[\\)]'
            }, {
                token: 'text',
                regex: '\\s+'
            }]
        };

        this.normalizeRules();
    }
}

class MqlMode extends TextMode {

    constructor() {
        super();
        this.HighlightRules = MqlHighlightRules;
    }
}

export type MqlEditorProps = Omit<CodeEditorProps, 'mode'>;

export const MqlEditor = (props: MqlEditorProps) => {
    const mode = useMemo(() => new MqlMode(), []);
    return <CodeEditor mode={mode} {...props} />;
};
